import * as React from "react"
const SvgLeft = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.819 12.148 3.905 3.903a.95.95 0 0 1 .276.7.95.95 0 0 1-.275.701.95.95 0 0 1-.701.276.95.95 0 0 1-.702-.276l-4.607-4.604a.9.9 0 0 1-.212-.325 1.1 1.1 0 0 1-.063-.375q0-.2.063-.376a.9.9 0 0 1 .212-.325l4.607-4.604a.95.95 0 0 1 .702-.275.95.95 0 0 1 .7.275.95.95 0 0 1 .276.7.95.95 0 0 1-.275.701z" />
  </svg>
)
export default SvgLeft
